'use client'

import { Title, Text, Stack, Card, Grid, GridCol, ThemeIcon } from '@mantine/core'
import Section from '@/components/ui/Section'
import { 
  IconUserCheck, 
  IconCreditCard, 
  IconShieldLock, 
  IconCalendarTime,
  IconMessages,
  IconSettings
} from '@tabler/icons-react'

export default function MentorOperationsSection() {
  return (
    <Section bg="grey" py="xl" contentWidth="lg">
      <Stack gap="xl">
        <div style={{ textAlign: 'center' }}>
          <Title order={2} size="h2" mb="md" c="navy.8">
            Everything Handled For You
          </Title>
          <Text size="lg" c="gray.7" maw={550} mx="auto">
            From application management to payments, we take care of the operational details so you can focus on&nbsp;mentoring.
          </Text>
        </div>

        <Grid gutter="lg" mt="xl">
          <GridCol span={{ base: 12, md: 4 }}>
            <Card
              padding="lg"
              radius="md"
              h="100%"
              style={{
                backgroundColor: 'white',
                boxShadow: '0 5px 20px rgba(0, 0, 0, 0.05)'
              }}
            >
              <Stack gap="md">
                <ThemeIcon size={60} radius="md" variant="light" color="emerald">
                  <IconUserCheck size={32} />
                </ThemeIcon>
                <Title order={3} size="h4" c="navy.8">
                  Simple Applications
                </Title>
                <Text size="sm" c="gray.7" style={{ lineHeight: 1.6 }}>
                  Review applications at your pace. Accept who you want to work with, decline politely. Choose your mentees.
                </Text>
              </Stack>
            </Card>
          </GridCol>

          <GridCol span={{ base: 12, md: 4 }}>
            <Card
              padding="lg"
              radius="md"
              h="100%"
              style={{
                backgroundColor: 'white',
                boxShadow: '0 5px 20px rgba(0, 0, 0, 0.05)'
              }}
            >
              <Stack gap="md">
                <ThemeIcon size={60} radius="md" variant="light" color="teal">
                  <IconCreditCard size={32} />
                </ThemeIcon>
                <Title order={3} size="h4" c="navy.8">
                  Easy Payments
                </Title>
                <Text size="sm" c="gray.7" style={{ lineHeight: 1.6 }}>
                  Get paid without the awkwardness. We handle billing and payment processing - no chasing payments or money conversations.
                </Text>
              </Stack>
            </Card>
          </GridCol>

          <GridCol span={{ base: 12, md: 4 }}>
            <Card
              padding="lg"
              radius="md"
              h="100%"
              style={{
                backgroundColor: 'white',
                boxShadow: '0 5px 20px rgba(0, 0, 0, 0.05)'
              }}
            >
              <Stack gap="md">
                <ThemeIcon size={60} radius="md" variant="light" color="cyan">
                  <IconShieldLock size={32} />
                </ThemeIcon>
                <Title order={3} size="h4" c="navy.8">
                  Privacy Protected
                </Title>
                <Text size="sm" c="gray.7" style={{ lineHeight: 1.6 }}>
                  Your email and phone stay private. All communication through the platform - never give out personal contact details.
                </Text>
              </Stack>
            </Card>
          </GridCol>

          <GridCol span={{ base: 12, md: 4 }}>
            <Card
              padding="lg"
              radius="md"
              h="100%"
              style={{
                backgroundColor: 'white',
                boxShadow: '0 5px 20px rgba(0, 0, 0, 0.05)'
              }}
            >
              <Stack gap="md">
                <ThemeIcon size={60} radius="md" variant="light" color="violet">
                  <IconCalendarTime size={32} />
                </ThemeIcon>
                <Title order={3} size="h4" c="navy.8">
                  Calendar Integration
                </Title>
                <Text size="sm" c="gray.7" style={{ lineHeight: 1.6 }}>
                  Connect your calendar for seamless scheduling. Built-in video calls keep everyone in sync without the back-and-forth.
                </Text>
              </Stack>
            </Card>
          </GridCol>

          <GridCol span={{ base: 12, md: 4 }}>
            <Card
              padding="lg"
              radius="md"
              h="100%"
              style={{
                backgroundColor: 'white',
                boxShadow: '0 5px 20px rgba(0, 0, 0, 0.05)'
              }}
            >
              <Stack gap="md">
                <ThemeIcon size={60} radius="md" variant="light" color="indigo">
                  <IconMessages size={32} />
                </ThemeIcon>
                <Title order={3} size="h4" c="navy.8">
                  Everything in One Place
                </Title>
                <Text size="sm" c="gray.7" style={{ lineHeight: 1.6 }}>
                  Messaging, video calls, scheduling, and payments all integrated. No switching between apps or losing track of conversations.
                </Text>
              </Stack>
            </Card>
          </GridCol>

          <GridCol span={{ base: 12, md: 4 }}>
            <Card
              padding="lg"
              radius="md"
              h="100%"
              style={{
                backgroundColor: 'white',
                boxShadow: '0 5px 20px rgba(0, 0, 0, 0.05)'
              }}
            >
              <Stack gap="md">
                <ThemeIcon size={60} radius="md" variant="light" color="blue">
                  <IconSettings size={32} />
                </ThemeIcon>
                <Title order={3} size="h4" c="navy.8">
                  You&apos;re in Control
                </Title>
                <Text size="sm" c="gray.7" style={{ lineHeight: 1.6 }}>
                  Choose who you work with and when to accept new mentees. Pause applications anytime. Mentor on your terms.
                </Text>
              </Stack>
            </Card>
          </GridCol>
        </Grid>
      </Stack>
    </Section>
  )
}
